import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {
	Card,
	CardContent, CardHeader, Collapse,
	Container, Divider, FormControl, InputLabel, MenuItem, Paper, Select, TextField, Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import QuaranteneDrawer from "./drawer/QuaranteneDrawer";
import {useHistory} from "react-router-dom";
import clsx from "clsx";
import HideAppBar from "../../widgets/header/HideAppBar";
import useGetAllQuarantene from "./utils/useGetAllQuarantene";
import {onClickDetails} from "../../../services/AutomationServices";
import {AppContext} from "../../../App";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {clean, getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import QuarantenaCard from "./detail/QuarantenaCard";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import CustomText from "../../widgets/inputs/CustomText";
import {
	codFRegisterNone,
	emailRegisterNone,
	nomeRegisterNone,
	phoneRegisterPrivate, valueRegisterNone
} from "../../../utils/RegisterUtils";
import {useForm} from "react-hook-form";
import CustomDateInput from "../../widgets/inputs/CustomDateInput";
import CustomSelect from "../../widgets/inputs/CustomSelect";
import {etichetteQuarantena} from "../../../utils/arrays/Generics";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";
import Button from "@mui/material/Button";


const GestioneQuarantene = () => {
	const classes = BaseStyle();
	const {errors, getValues, control, reset} = useForm({
		mode: "onChange",
		defaultValues: sessionStorage.getItem("soggettoSearch") ? {search: JSON.parse(sessionStorage.getItem("soggettoSearch"))} : {}
	})
	const contattaciClasses = ContattaciStyle();
	const history = useHistory();
	const appContext = useContext(AppContext);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [active, setActive] = useState(false);
	const [stato, setStato] = useSessionStorage("statoQua", "NUOVA");
	const [filtersTipo, setFiltersTipo] = useSessionStorage("filtersTipo", "");
	const [filtersMonitoraggio, setFiltersMonitoraggio] = useSessionStorage("filtersMonitoraggio", "");
	const [scoreFilter, setScoreFilter] = useSessionStorage("scoreFilter", "");
	const [pageNumber, setPageNumber] = useState(0);
	const [value, setValue] = useState("");
	const [open, setOpen] = useState(false);
	const [soggettoSearch, setSoggettoSearch] = useSessionStorage("soggettoSearch", {}) //useState({});
	const [selected, setSelected] = useState("")
	const [sort, setSort] = useSessionStorage("sort", "ultimaModifica");
	const [dir, setDir] = useSessionStorage("dir", "ASC");
	const [ageFilter, setAgeFilter] = useSessionStorage("age", null);
	const {
		loading,
		error,
		hasMore,
		quarantene
	} = useGetAllQuarantene(stato, pageNumber, filtersTipo, filtersMonitoraggio, soggettoSearch, value, scoreFilter, sort, dir, active, ageFilter)
	const observer = useRef();
	
	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, [setStato]);
	
	const handleFiltersTipo = useCallback((newValue) => {
		setPageNumber(0);
		setFiltersTipo(newValue);
	}, [setFiltersTipo])
	
	const handleFiltersMonitoraggio = useCallback((newValue) => {
		setPageNumber(0);
		setFiltersMonitoraggio(newValue);
	}, [setFiltersMonitoraggio])
	
	const handleFiltersScore = useCallback((newValue) => {
		setPageNumber(0);
		setScoreFilter(newValue);
	}, [setScoreFilter])
	
	const handleSort = useCallback((newValue) => {
		setPageNumber(0);
		setSort(newValue);
	}, [setSort])
	
	const handleDir = useCallback((newValue) => {
		setPageNumber(0);
		setDir(newValue);
	}, [setDir])
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const onClickQuarantena = (quarantena) => {
		setSelected(quarantena);
		onClickDetails(quarantena.idFocolaio, "focolaio", "modify", automationDispatch);
	}
	
	const onSearch = useCallback(() => {
		if (open) {
			let soggetto = getValues()?.["search"];
			setSoggettoSearch(clean(soggetto));
			setPageNumber(0);
		}
	}, [open, getValues, setSoggettoSearch])
	
	const handleKeyDown = useCallback((event) => {
		if ((event.ctrlKey && event.keyCode === 13) || event.keyCode === 13) {
			onSearch();
		}
	}, [onSearch])
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/focolai/" + selected.idFocolaio + "/soggetto/" + selected.soggetto.idSoggetto);
			} else {
				setOpenSnackbar("warning", ("L'ordinanza è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	useEffect(() => {
		setPageNumber(0);
	}, [stato, filtersTipo, filtersMonitoraggio, scoreFilter, sort, dir, value, ageFilter])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Autosorveglianze ed isolamenti"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper
								className={clsx(classes.filterSearchPaper, classes.roundBorder)}
								component={"section"}>
								<TextField
									placeholder={"Cerca per ..."}
									value={value}
									onChange={(e) => setValue(e.target.value)}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" onClick={onSearch} size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="start">
											<Tooltip title={"Ricerca avanzata"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => setOpen(!open)}
                                                    className={clsx(classes.expand, {
                                                        [classes.expandOpen]: open,
                                                    })}
                                                    size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder},
									}}
								/>
								<Collapse in={open} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => handleSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"ultimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"ultimoMonitoraggio"}>Data ultima monitoraggio</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
													<MenuItem value={"dataCreazione"}>Data creazione</MenuItem>
													<MenuItem value={"dataInizio"}>Data inizio</MenuItem>
													<MenuItem value={"dataFine"}>Data fine</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => handleDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più vecchio al più nuovo</MenuItem>
													<MenuItem value={"DESC"}>Dal più nuovo al più vecchio</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12}>
											<Divider/>
										</Grid>
										<Grid item xs={12}>
											<Typography style={{paddingLeft: 10}}>
												<b>Filtro per ordinanza</b>
											</Typography>
											<Typography color={"textSecondary"} style={{paddingLeft: 10, paddingBottom: 10}}>
												Applica i filtri indicando il tipo di ordinanza che stai cercando
											</Typography>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomDateInput
												label={"Data inizio"}
												control={control}
												defaultValue={null}
												rules={{required: false}}
												name={"search.dataInizio"}
												error={errors["search"]?.["dataInizio"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomDateInput
												label={"Data fine"}
												control={control}
												defaultValue={null}
												rules={{required: false}}
												name={"search.dataFine"}
												error={errors["search"]?.["dataFine"]}
											/>
										</Grid>
										<Grid item xs={12} sm={2}>
											<CustomText
												control={control}
												rules={valueRegisterNone}
												label={"Id ordinanza"}
												handleKeyDown={handleKeyDown}
												autoFocus={false}
												name={"search.id"}
												error={errors["search"]?.["id"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomSelect
												name={"search.tag"}
												label={"Seleziona un'etichetta da mostrare"}
												control={control}
												defaultValue={""}
												none={true}
												noneValue={""}
												autoFocus={false}
												rules={{required: false}}
												error={errors["search"]?.["tag"]}
											>
												{
													etichetteQuarantena.map((item) => {
														return (
															<MenuItem value={item} key={item}>
																{item}
															</MenuItem>
														)
													})
												}
											</CustomSelect>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomSelect
												name={"search.protocollo"}
												label={"Accetta il tampone"}
												control={control}
												defaultValue={""}
												none={true}
												noneValue={""}
												autoFocus={false}
												rules={{required: false}}
												error={errors["search"]?.["protocollo"]}
											>
												<MenuItem value={"true"}>
													Solo chi accetta
												</MenuItem>
												<MenuItem value={"false"}>
													Solo chi NON accetta
												</MenuItem>
												<MenuItem value={""}>
													Tutti
												</MenuItem>
											</CustomSelect>
										</Grid>
										<Grid item xs={12}>
											<Divider/>
										</Grid>
										<Grid item xs={12}>
											<Typography style={{paddingLeft: 10}}>
												<b>Filtro per soggetto</b>
											</Typography>
											<Typography color={"textSecondary"} style={{paddingLeft: 10, paddingBottom: 10}}>
												Indica nei campi sottostanti il soggetto della quarantena che stai cercando
											</Typography>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={codFRegisterNone}
												label={"Codice fiscale"}
												autoFocus={false}
												handleKeyDown={handleKeyDown}
												name={"search.codF"}
												error={errors["search"]?.["codF"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={phoneRegisterPrivate}
												label={"Cellulare"}
												handleKeyDown={handleKeyDown}
												autoFocus={false}
												name={"search.cell"}
												error={errors["search"]?.["cell"]}
											/>
										</Grid>
										
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={nomeRegisterNone}
												label={"Nome"}
												autoFocus={false}
												handleKeyDown={handleKeyDown}
												name={"search.nome"}
												error={errors["search"]?.["nome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={nomeRegisterNone}
												label={"Cognome"}
												autoFocus={false}
												name={"search.cognome"}
												handleKeyDown={handleKeyDown}
												error={errors["search"]?.["cognome"]}
											/>
										</Grid>
										
										<Grid item xs={12}>
											<CustomText
												control={control}
												rules={emailRegisterNone}
												label={"Email"}
												autoFocus={false}
												name={"search.email"}
												handleKeyDown={handleKeyDown}
												error={errors["search"]?.["email"]}
											/>
										</Grid>
										<Grid item xs={12} className={classes.flexRight}>
											<Button variant={"text"} disableElevation style={{borderRadius: 24, marginLeft: 5}}
											        onClick={() => {
												        reset();
												        setSoggettoSearch({})
												        sessionStorage.removeItem("soggettoSearch");
											        }}>
												<b>Rimuovi filtri</b>
											</Button>
											<Button variant={"contained"} disableElevation color={"primary"} onClick={onSearch}
											        style={{borderRadius: 24, marginLeft: 5}}>
												<b>Cerca</b>
											</Button>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>
						
						<Grid item xs={12}>
							
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									<QuaranteneDrawer stato={stato} selectMenuItem={setMenuSelected} filters={filtersTipo}
									                  filtersMonitoraggio={filtersMonitoraggio} scoreFilter={scoreFilter}
									                  setScoreFilter={handleFiltersScore} active={active} setActive={setActive}
									                  setFilters={handleFiltersTipo} ageFilter={ageFilter} setAgeFilter={setAgeFilter}
									                  setMenuFilterMonitoraggio={handleFiltersMonitoraggio}/>
									
									<div className={classes.content}
									     style={{maxHeight: "112vh", overflowY: "auto", overflowX: "hidden",}}>
										{
											quarantene.map((quarantena, index) => {
												if (quarantene.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={quarantena.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}
															                setValue={setValue}/>
														</Card>
													)
												} else {
													return (
														<Card key={quarantena.id} className={clsx(classes.roundBorder, classes.mailCard)}>
															<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}
															                setValue={setValue}/>
														</Card>
													)
												}
											})
										}
										
										{!loading && !error && quarantene.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono quarantene! Goditi questo meritato relax
											</Alert>}
										{!loading && error &&
											<Alert severity="error" style={{borderRadius: 24}}>
												<AlertTitle>Errore</AlertTitle>
												Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
												sviluppatori.
											</Alert>}
										{loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
									
									</div>
								
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(GestioneQuarantene);
